import axios from 'axios';
import { functions } from '@/vendors/firebase/firebase';

export default {
  async sendEmail(mailRecipient, mailSender, body, file, bodyCallback) {
    const callable = functions.httpsCallable('supplierEmail');
    return callable({
      subject: 'Commande',
      text: body,
      file,
      mailR: mailRecipient,
      mailS: mailSender,
    })
      .then((data) => {
        console.log(data);
        const callableCallback = functions.httpsCallable('callbackEmail');
        return callableCallback({
          subject: 'Commande',
          text: bodyCallback,
          mailR: mailSender,
          mailS: mailSender,
        });
      });
  },

  async errorEmail(mailRecipient, mailSender, body) {
    mailRecipient.forEach((recipient) => {
      const callable = functions.httpsCallable('errorEmail');
      return callable({
        subject: 'Erreur passage de commande',
        text: body,
        mailR: recipient,
        mailS: mailSender,
      });
    });
  },

  async checkSentMail(mailRecipient, mailSender, bodyCallback) {
    mailRecipient.forEach((recipient) => {
      const callableCheck = functions.httpsCallable('callbackEmail');
      return callableCheck({
        subject: 'confirmation commande',
        text: bodyCallback,
        mailR: recipient,
        mailS: mailSender,
      });
    });
  },
  async sendMagicLink(email) {
    return axios.get(process.env.VUE_APP_REQUEST_SHOP_MAGIC_LINK_ENDPOINT, {
      params: {
        callbackURL: `${window.location.origin}/${process.env.VUE_APP_MAGIC_LINK_CALLBACK_ENDPOINT}`,
        email,
      },
    });
  },
};
